const {
  navigateBackAll,
  navigateReplaceAll
} = require("../shim/frvrSDK.js");
var vP15056 = require("./game-overlay.js");
var context = module.exports;
context.active = true;
context.menu2 = "rcY";
var v12225 = true;
context.isMobileControls = false;
context.hasEndScreen = false;
context.previewType = 0;
context.loading = false;
context.hidden = false;
context.isUpdating = false;
context.embedPlayer = null;
context.useEmbedPlayer = true;
context.toggleMenu = p15057 => {
  if (context.isUpdating) {
    p15057 = false;
  }
  menuHolder.style.display = p15057 ? "block" : "none";
  speakerDisplay.style.display = p15057 ? "none" : "block";
  context.toggleMenuHider(p15057);
  if (p15057) {
    endUI.style.display = "none";
    uiBase.classList.toggle("onEndScrn", false);
    instructionHolder.style.display = "block";
    if (windowHolder.style.display != "block") {
      baseLinks.style.display = "block";
    }
    if (centerLeaderDisplay.style.display != "none") {
      centerLeaderDisplay.style.display = "none";
    }
  }
  context.active = true;
  context.previewType = 0;
  menuClassContainer.style.visibility = "";
};
context.loadSpinner = () => {
  instructions.innerHTML = "<div style='width:100%;text-align:center;transform:scale(1.3);'><div class='lds-ring'><div></div><div></div><div></div><div></div></div></div>";
};
context.toggleMobileUI = function (p15058) {
  context.isMobileControls = p15058;
  fullMenHider.style.display = "block";
  aHider.classList.toggle("forceHidden", false);
};
context.toggleWholeUI = p15059 => {
  if (p15059) {
    fullMenHider.classList.remove("forceHidden");
    customGUIHolder.classList.remove("forceHidden");
    gameUIHider.classList.remove("forceHidden");
  } else {
    fullMenHider.classList.add("forceHidden");
    customGUIHolder.classList.add("forceHidden");
    gameUIHider.classList.add("forceHidden");
  }
};
context.hideUI = p15060 => {
  if (!p15060) {
    context.toggleMenu(false);
  }
  inGameUI.style.display = "none";
  customGUIHolder.style.display = "none";
  overlay.style.display = "none";
  vignette.style.display = "none";
  spectateUI.style.display = "none";
  aimRecticle.style.display = "none";
  if (!p15060) {
    instructionHolder.style.display = "none";
  }
  baseLinks.style.display = "none";
  speakerDisplay.style.right = "20px";
  purchaseHolder.style.display = "none";
  consentBlock.style.display = "none";
  context.active = false;
};
context.hideDiscon = () => {
  chatHolder.style.display = "none";
  speakerDisplay.style.display = "none";
  purchaseHolder.style.display = "none";
};
context.showEndScreen = p15061 => {
  context.hasEndScreen = true;
  endMidHolder.style.display = "none";
  matchVoteHolder.style.display = "none";
  teamTotal0.style.display = "none";
  teamTotal1.style.display = "none";
  if (!p15061) {
    endInfo.style.display = "none";
  }
  endUI.style.display = p15061 ? "none" : null;
  uiBase.classList.toggle("onEndScrn", !p15061);
  context.hideUI(p15061);
};
context.toggleWindow = p15062 => {
  context.previewType = 0;
  menuClassContainer.style.visibility = "";
  windowHolder.style.display = p15062 ? "block" : "none";
  baseLinks.style.display = p15062 ? "none" : "block";
  context.updatePlayInstructions();
  if (!p15062) {
    window.closeWindow();
  }
  aHolder.style.zIndex = p15062 ? "999999" : "99999999999";
};
context.toggleMenuHider = p15063 => {
  menuHider.style.display = p15063 ? "block" : "none";
  uiBase.classList.toggle("onMenu", p15063);
  uiBase.classList.toggle("onDeathScrn", false);
  uiBase.classList.toggle("onSpect", window.spectating && !p15063);
  gameNameHolder.style.display = p15063 ? null : "none";
  spectButton.style.display = v12225 && p15063 ? null : "none";
  if (p15063) {
    spinUI.style.display = "none";
    spinUIBtns.style.display = "none";
  }
  if (!p15063) {
    clearPops();
  }
};
context.toggleEndScreen = () => {
  if (context.hasEndScreen && endInfo.style.display == "block") {
    if (endUI.style.display == "none") {
      endUI.style.display = null;
      uiBase.classList.toggle("onEndScrn", true);
      endInfo.style.display = "block";
      victorySub.style.display = "";
      menuHolder.style.display = "none";
      context.hideUI();
    } else {
      context.toggleMenu(true);
    }
  }
};
context.setShowSpect = p15064 => {
  v12225 = p15064;
  spectButton.style.display = p15064 ? null : "none";
};
context.setShowSelTeam = p15065 => teamSelector.style.display = p15065 ? "block" : "none";
context.showError = p15066 => {
  context.toggleMenu(true);
  instructions.innerHTML = p15066;
};
context.toggleGameUI = p15067 => {
  var v12226 = p15067 && !window.spectating;
  spectateUI.style.display = window.spectating && p15067 ? "block" : "none";
  if (window.spectating) {
    propControlHolder.style.display = "none";
  }
  mobileUI.style.display = p15067 && context.isMobileControls ? "block" : "none";
  gameMessage.style.display = v12226 ? "block" : "none";
  roundMessage.style.display = v12226 ? "block" : "none";
  topLeftMain.style.display = p15067 ? "inline-block" : "none";
  topLeftMap.style.display = p15067 ? "block" : "none";
  topLeftMatchData.style.display = v12226 ? "block" : "none";
  topLeftData.style.display = v12226 ? "inline-block" : "none";
  topLeftBottom.style.display = v12226 ? "block" : "none";
  topRight.style.display = p15067 ? "block" : "none";
  reloadMsg.style.display = v12226 ? "block" : "none";
  bottomLeftHolder.style.display = v12226 ? "block" : "none";
  weapHolder.style.display = v12226 && !context.isMobileControls ? "grid" : "none";
  bottomRight.style.display = v12226 ? "block" : "none";
  deathUIHolder.style.display = p15067 ? "none" : "block";
  speakerDisplay.style.right = (p15067 ? 380 : 20) + "px";
  overlay.style.display = v12226 ? "block" : "none";
  vignette.style.display = v12226 ? "block" : "none";
  vP15056.interactProg.display = false;
  vP15056.interactMProg.display = false;
  context.updateCrosshair(0, 0);
  if (interactMsg) {
    interactMsg.style.display = "none";
  }
  topRight.style.marginRight = null;
  if (p15067 && context.embedPlayer) {
    context.toggleEmbedPlayer(false);
  }
};
context.toggleControlUI = p15068 => {
  if (context.loading) {
    p15068 = false;
  }
  spectateUI.style.display = window.spectating && p15068 && !context.hideGameUI ? "block" : "none";
  inGameUI.style.display = p15068 && context.active && !context.hideGameUI ? "block" : "none";
  customGUIHolder.style.display = p15068 && context.active && !context.hideGameUI ? "block" : "none";
  mobileUI.style.display = p15068 && context.active && context.isMobileControls ? "block" : "none";
  overlay.style.display = p15068 && context.active && !context.hideGameUI ? "block" : "none";
  vignette.style.display = p15068 && context.active && !context.hideGameUI ? "block" : "none";
  aimRecticle.style.display = p15068 && context.active ? "block" : "none";
  instructionHolder.style.display = !p15068 && context.active ? "block" : "none";
  centerLeaderDisplay.style.display = "none";
  aHolder.style.display = p15068 ? "none" : "block";
  if (context.isMobileControls) {
    uiBase.classList.toggle("onGameM", p15068);
  }
  uiBase.classList.toggle("onGame", p15068);
  infoHolder.style.display = p15068 ? "none" : null;
  speakerDisplay.style.display = p15068 && context.active ? "block" : "none";
  if (endUI.style.display) {
    menuHolder.style.display = p15068 ? "none" : "block";
    context.toggleMenuHider(!p15068);
  }
  clearPops();
  var v12227 = document.getElementById("ot-sdk-btn-floating");
  if (v12227) {
    v12227.style.display = p15068 ? "none" : "block";
  }
  if (!p15068) {
    vP15056.sprayWheelClose();
    vP15056.propWheelClose();
  }
  if (!p15068 && context.embedPlayer && context.useEmbedPlayer) {
    context.toggleEmbedPlayer(true);
  }
};
context.updateCrosshair = (p15069, p15070) => {
  vP15056.crosshairOpacity = p15070;
  vP15056.crosshairScale = p15069;
};
context.toggleEmbedPlayer = p15071 => {
  if (context.embedPlayer) {
    if (p15071 && context.useEmbedPlayer) {
      context.embedPlayer.play();
    } else {
      context.embedPlayer.pause();
    }
  }
};